module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings.oracle.title":"Oracle Cloud Connections","settings.oracle.subtitle":"All cloud connections importing OCI usage data in this tenant."}}')
  delete Component.options._Ctor
}
